import { Avatar, IconButton } from '@material-ui/core'
import ICONS from './../../assets/icons'
import './closeButton.scss'
import { useSelector } from 'react-redux'

const CloseButton = ({ onClick, disabled = false }) => {
  const { Mode } = useSelector((state) => state)

  return (
    <IconButton 
      className="close-button-container" 
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <Avatar
        className="close-button-icon"
        src={ICONS[`${Mode.selectedMode}Close`]}
      />
    </IconButton>
  )
}

export default CloseButton
